<template>
  <!--Sector Sanitari Barcelona Ciutat-->
  <svg
    id="chart"
    viewBox="0 0 200 70"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="850px"
    @click="seleccionarTotsElsSectors"
    v-if="regioSanitariaSeleccionada === 'barcelona-ciutat'"
  >
    <g transform="translate(-450, -455)">
      <path
        id="46"
        title="Barcelona Esquerra"
        class="land-sector"
        d="M 504.41 519.64 499.05 503.95 486.27 488.83 496.99 485.33 503.99 491.82 509.09 498.87 510.93 503.26 504.41 519.64 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(46, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('barcelona-ciutat', 46)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="4.5"
        x="505"
        y="503"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(46, pregunta) }}
      </text>

<path
        id="71"
        title="Barcelona Litoral Mar"
        class="land-sector"
        d="M 510.93 503.26 509.09 498.87 513.39 489 514.47 488.96 515.78 485.23 518.55 484.85 524.92 487.89 510.93 503.26 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(71, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('barcelona-ciutat', 71)"
      >
        <title>Sector Sanitari {{title}}</title>
      </path>
      <text
        font-size="4.5"
        x="520"
        y="490"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(71, pregunta) }}
      </text>

<path
        id="70"
        title="Barcelona Dreta"
        class="land-sector"
        d="M 503.99 491.82 515.78 485.23 514.47 488.96 513.39 489 509.09 498.87 503.99 491.82 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(70, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('barcelona-ciutat', 70)"
      >
        <title>Sector Sanitari {{title}}</title>
      </path>
      <text
        font-size="4.5"
        x="510"
        y="493"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(70, pregunta) }}
      </text>

<path
        id="47"
        title="Barcelona Nord"
        class="land-sector"
        d="M 496.99 485.33 499.22 479.63 507.65 455.38 523.09 463.38 518.55 484.85 515.78 485.23 503.99 491.82 496.99 485.33 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(47, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('barcelona-ciutat', 47)"
      >
        <title>Sector Sanitari {{title}}</title>
      </path>
      <text
        font-size="4.5"
        x="515"
        y="470"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(47, pregunta) }}
      </text>
    </g>
    <!-- Fi Regio Sanitaria Barcelona-->
  </svg>
  <svg
    id="terres-ebre"
    viewBox="0 0 800 400"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="450px"
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'terres-ebre'"
  >
    <!--Regio Sanitaria Terres Ebre-->
    <g transform="translate(300, -450)">
      <path
        v-show="regioSanitariaSeleccionada === 'terres-ebre'"
        id="6360"
        title="Terres de l'Ebre"
        class="land-sector"
        d="M 60.96 525.58 80.56 507.33 118.25 523.16 168.5 512.39 168.26 528.42 135.94 538.61 128.6 558.51 142.71 584.24 167.03 599.05 156.21 621.87 176.62 643.07 135.77 685.71 176.35 709.4 175.68 724.45 149.19 740.17 109.21 745.66 86.2 778 55.01 749.16 27.48 740.67 31.36 721.35 1 705.54 29.47 676.99 19.94 655.92 34.45 628.02 12.55 588.77 16.36 571.29 38.74 564.06 60.96 525.58 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6360, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('terres-ebre', 6360)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>

      <text
        font-size="35"
        x="100"
        y="620"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6360, pregunta) }}
      </text>
    </g>
    <!--Fi Regio Sanitaria Terres Ebre-->
  </svg>
  <svg
    id="lleida"
    viewBox="0 0 800 400"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="450px"
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'lleida'"
  >
    <!--Regio Sanitaria Lleida-->
    <g transform="translate(200, -200)">
      <path
        id="6112"
        title="Lleida Est"
        class="land-sector"
        d="M 226.17 456.55 209.59 429.89 150.47 432.1 159.84 394.6 141.98 389.17 140.1 340.01 120.8 317.58 111.23 307.08 142.03 262.26 162.43 274.89 201.07 281.75 238.16 277.85 256.51 250.48 279.97 269.13 281.83 310.92 292.73 304.94 304.59 326.87 299.05 347.75 319.42 356.85 322.75 399.44 329.91 412.8 307.68 420.06 318.02 438.81 269.85 440.92 243.61 467.51 226.17 456.55 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6112, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('lleida', 6112)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="240"
        y="350"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6112, pregunta) }}
      </text>
      <path
        id="6113"
        class="land-sector"
        title="Lleida Oest"
        d="M 60.96 525.58 45.64 486.54 78.96 438.35 74.98 418.18 55.22 418.46 50.7 391.01 69.27 366.69 121.9 329.99 120.8 317.58 140.1 340.01 141.98 389.17 159.84 394.6 150.47 432.1 209.59 429.89 226.17 456.55 235.41 469.73 206.78 503.94 191.82 506.14 168.5 512.39 118.25 523.16 80.56 507.33 60.96 525.58 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6113, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('lleida', 6113)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="150"
        y="470"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6113, pregunta) }}
      </text>
    </g>
    <!--FI Regio Sanitaria Lleida-->
  </svg>
  <svg
    id="camp-tarragona"
    viewBox="0 0 800 400"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="450px"
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'camp-tarragona'"
  >
    <!--Regio Sanitaria Camp Tarragona-->
    <g transform="translate(200, -400)">
      <path
        id="6202"
        class="land-sector"
        title="Camp de Tarragona Oest"
        d="M 168.5 512.39 191.82 506.14 214.25 505 228.37 533.46 260.68 552.25 243.21 598.53 204.95 612.65 176.62 643.07 156.21 621.87 167.03 599.05 142.71 584.24 128.6 558.51 135.94 538.61 168.26 528.42 168.5 512.39 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6202, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('camp-tarragona', 6202)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="200"
        y="560"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6202, pregunta) }}
      </text>
      <path
        id="6201"
        class="land-sector"
        title="Camp de Tarragona Est"
        d="M 243.21 598.53 260.68 552.25 228.37 533.46 214.25 505 191.82 506.14 206.78 503.94 235.41 469.73 226.17 456.55 243.61 467.51 269.85 440.92 298.18 481.65 326.76 474.85 345.8 519.57 323.92 530.63 338.9 567.24 243.21 598.53 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6201, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('camp-tarragona', 6201)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="300"
        y="530"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6201, pregunta) }}
      </text>
    </g>
    <!--Fi Regio Sanitaria Camp Tarragona-->
  </svg>
  <svg
    id="metropolita-nord"
    viewBox="0 0 600 200"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="800px" 
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'metropolita-nord'"
  >
    <!--Regio Sanitaria Metropolita Nord-->
    <g transform="translate(-350, -350)">
      <path
        id="7643"
        class="land-sector"
        title="Vallès Occidental Oest"
        d="M 464.28 480.38 462.94 479.06 447.31 436.42 470.13 407.63 485.47 461.43 499.22 479.63 496.99 485.33 486.27 488.83 484.25 487.53 481.53 481.99 464.28 480.38 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7643, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('metropolita-nord', 7643)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="15"
        x="465"
        y="440"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
        
      >
        {{ getPercentatge(7643, pregunta) }}
      </text>
      <path
        id="7642"
        class="land-sector"
        title="Vallès Oriental"
        d="M 489.44 391.4 527.75 384.51 534.72 361.83 559.08 370.86 572.24 359.93 617.05 385.54 619.49 403.15 601.42 414.38 572.66 417.79 546.04 449.96 523.09 463.38 489.44 391.4 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7642, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('metropolita-nord', 7642)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="15"
        x="560"
        y="400"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7642, pregunta) }}
      </text>
      <path
        id="7667"
        class="land-sector"
        title="Barcelonès Nord - Maresme"
        d="M 523.85 490.04 518.55 484.85 513.79 473.82 513.6 471.55 523.09 463.38 546.04 449.96 572.66 417.79 601.42 414.38 610.11 434.05 539.4 471.06 523.85 490.04 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7667, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('metropolita-nord', 7667)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="15"
        x="590"
        y="430"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7667, pregunta) }}
      </text>
      <path
        id="7644"
        class="land-sector"
        title="Vallès Occidental Est"
        d="M 470.13 407.63 489.44 391.4 523.09 463.38 513.6 471.55 506.51 477.21 499.22 479.63 485.47 461.43 470.13 407.63 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7644, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('metropolita-nord', 7644)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="15"
        x="500"
        y="450"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7644, pregunta) }}
      </text>
    </g>
    <!--Fi Regio Sanitaria Metropolita Nord-->
  </svg>
  <svg
    id="alt-pirineu-aran"
    viewBox="0 0 800 400"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="450px"
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'alt-pirineu-aran'"
  >
    <!--Regio sanitaria Alt Pirineu Aran-->
    <g transform="translate(150, 50)">
      <path
        id="7107"
        class="land-sector"
        title="Aran"
        d="M 235.94 27.94 211.46 93.08 195.01 80.38 168.35 84.56 153.94 81.13 141.01 32.65 156.07 1 209.93 26.59 235.94 27.94 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7107, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('alt-pirineu-aran', 7107)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="100"
        y="50"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7107, pregunta) }}
      </text>
      <path
        id="7164"
        title="Pirineu"
        class="land-sector"
        d="M 292.73 304.94 281.83 310.92 279.97 269.13 256.51 250.48 238.16 277.85 201.07 281.75 162.43 274.89 142.03 262.26 166.89 171.52 149.17 129.14 168.35 84.56 195.01 80.38 211.46 93.08 235.94 27.94 267.01 54.52 313.99 51.89 327.41 73.5 339.97 122.2 333.65 144.93 360.23 148.28 387.6 128.47 422.72 130.13 449.81 145.15 474.17 178.43 459.04 189.9 446.1 186.12 393.35 200.65 374.11 225.67 358.98 222.33 332.38 243.63 310.37 242.21 310.68 291.47 292.73 304.94 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7164, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('alt-pirineu-aran', 7164)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="280"
        y="180"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7164, pregunta) }}
      </text>
    </g>
    <!--Fi Regio Sanitaria Alt Pirineu Aran-->
  </svg>
  <svg
    id="girona"
    viewBox="0 0 800 400"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="450px"
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'girona'"
  >
    <!--Regio Sanitaria Girona-->
    <g transform="translate(-250, -100)">
      <path
        id="6461"
        class="land-sector"
        title="Girona Nord"
        d="M 709.81 377.54 709.49 353.1 691.63 317.68 713.81 298.97 705.67 258.04 686.04 273.31 673.93 228 634.53 236.5 605.06 253.54 618.2 275.67 592.08 275.35 575.02 274.53 556.24 248.93 484.52 249.1 476.76 209.89 487.22 198.54 459.04 189.9 474.17 178.43 502.18 156.95 533.88 148.53 572.68 164.45 589.5 181.89 636.9 181.27 631.67 165.85 667.52 156.02 677.49 142.47 726.93 137.76 737.99 153.61 757.36 150.17 757.23 175.41 796.56 188.88 786.02 211.04 759.66 207.49 744.51 227.54 747.62 252.47 769.56 272.44 774.13 305.28 767.43 331.39 709.81 377.54 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6461, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('girona', 6461)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="700"
        y="200"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6461, pregunta) }}
      </text>
      <path
        id="6462"
        class="land-sector"
        title="Girona Sud"
        d="M 601.42 414.38 619.49 403.15 617.05 385.54 572.24 359.93 587.55 317.93 592.08 275.35 618.2 275.67 605.06 253.54 634.53 236.5 673.93 228 686.04 273.31 705.67 258.04 713.81 298.97 691.63 317.68 709.49 353.1 709.81 377.54 661.71 411.42 610.11 434.05 601.42 414.38 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6462, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('girona', 6462)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="650"
        y="350"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6462, pregunta) }}
      </text>
    </g>
    <!--Fi Regio Sanitaria Girona-->
  </svg>
  <svg
    id="catalunya-central"
    viewBox="0 0 800 400"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="450px"
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'catalunya-central'"
  >
    <g transform="translate(-50, -150)">
      <!--Regio Sanitaria Catalunya Central-->
      <path
        id="6701"
        class="land-sector"
        title="Bages - Berguedà - Moianès - Solsonès"
        d="M 393.81 418.36 371.87 393.78 322.75 399.44 319.42 356.85 299.05 347.75 304.59 326.87 292.73 304.94 310.68 291.47 310.37 242.21 332.38 243.63 358.98 222.33 374.11 225.67 393.35 200.65 446.1 186.12 459.04 189.9 487.22 198.54 476.76 209.89 484.52 249.1 444.85 311.81 476.43 306.89 480.04 328.15 501.42 323.93 515.03 383.42 527.75 384.51 489.44 391.4 470.13 407.63 447.31 436.42 393.81 418.36 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6701, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('catalunya-central', 6701)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="400"
        y="350"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6701, pregunta) }}
      </text>
      <path
        id="6745"
        class="land-sector"
        title="Osona"
        d="M 527.75 384.51 515.03 383.42 501.42 323.93 480.04 328.15 476.43 306.89 444.85 311.81 484.52 249.1 556.24 248.93 575.02 274.53 592.08 275.35 587.55 317.93 572.24 359.93 559.08 370.86 534.72 361.83 527.75 384.51 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(6745, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('catalunya-central', 6745)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="550"
        y="300"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(6745, pregunta) }}
      </text>
      <!--Fi Regio Sanitaria Catalunya Central-->
    </g>
  </svg>
  <svg
    id="metropolita-sud"
    viewBox="0 0 850 400"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="1000px"
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'metropolita-sud'"
  >
    <!--Regio Sanitaria Metropolita Sud-->
    <g transform="translate(-250, -400)">
      <path
        id="7501"
        class="land-sector"
        title="Baix Llobregat Centre - Nord"
        d="M 464.28 480.38 481.53 481.99 484.25 487.53 486.27 488.83 492.32 493.49 492.22 500.34 483.56 512.21 464.28 480.38 Z M 462.94 479.06 435.41 493.57 411.95 450.07 430.48 457.56 393.81 418.36 447.31 436.42 462.94 479.06 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7501, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('metropolita-sud', 7501)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="15"
        x="440"
        y="470"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7501, pregunta) }}
      </text>
      <path
        id="7502"
        class="land-sector"
        title="Baix Llobregat Delta Litoral"
        d="M 445.56 540.58 427.73 524.28 435.41 493.57 462.94 479.06 464.28 480.38 483.56 512.21 484.81 534.89 445.56 540.58 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7502, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('metropolita-sud', 7502)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="15"
        x="460"
        y="520"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7502, pregunta) }}
      </text>
      <path
        id="7503"
        title="L'Hospitalet de Llobregat - El Prat de Llobregat"
        class="land-sector"
        d="M 484.81 534.89 483.56 512.21 492.22 500.34 496.97 502.02 504.41 519.64 484.81 534.89 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7503, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('metropolita-sud', 7503)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="15"
        x="521"
        y="510"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7503, pregunta) }}
      </text>
    </g>
    <!--Fi Regio Sanitaria Metropolita Sud-->
  </svg>
  <svg
    id="penedes"
    viewBox="0 0 800 400"
    preserveAspectRatio="xMidYMid meet"
    pointer-events="auto"
    width="450px"
    @click="seleccionarTotsElsSectors"
    v-else-if="regioSanitariaSeleccionada === 'penedes'"
  >
    <!--Sector Sanitari Penedes-->
    <g transform="translate(50, -350)">
      <path
        id="7001"
        class="land-sector"
        title="Penedes"
        d="M 338.9 567.24 323.92 530.63 345.8 519.57 326.76 474.85 298.18 481.65 269.85 440.92 318.02 438.81 307.68 420.06 329.91 412.8 322.75 399.44 371.87 393.78 393.81 418.36 430.48 457.56 411.95 450.07 435.41 493.57 427.73 524.28 445.56 540.58 385.07 559.1 338.9 567.24 Z"
        stroke-width="1.8"
        stroke-opacity="0"
        :fill="getFillColor(getPercentatge(7001, pregunta), pregunta)"
        stroke="rgb(0, 123, 255)"
        pointer-events="all"
        style="cursor: pointer;"
        @mouseover="getInfo"
        @click="actualitzarSectorSanitari('penedes', 7001)"
      >
        <title>Sector Sanitari {{ title }}</title>
      </path>
      <text
        font-size="35"
        x="380"
        y="500"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="black"
        pointer-events="none"
      >
        {{ getPercentatge(7001, pregunta) }}
      </text>
    </g>
  </svg>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      id: "",
      sectorSeleccionat: null,
    };
  },
  props: {
    data: {
      type: Array,
    },
    pregunta: {
      type: Number,
    },
    regioSanitariaSeleccionada: {
      type: String,
    },
    sectorSanitariSeleccionat: {
      type: Number,
    },
  },
  methods: {
    getInfo(e) {
      this.title = e.target.getAttribute("title");
    },
    getPercentatge(sector, pregunta) {
      // Busca les dades de la regio en el prop 'data'
      const regionData = this.data.find(
        (item) => item.sectorSanitari === sector
      );
      //Si la pregunta es de Satisfaccio no s'ha d'afegir el char %
      if (regionData && regionData.preguntaPercentatge) {
        if (pregunta === 15 || pregunta === 16) {
          return regionData.preguntaPercentatge[pregunta] || 0;
        } else {
          return regionData.preguntaPercentatge[pregunta] + "%" || 0; 
        }
      } else {
        return "";
      }
    },
    getFillColor(percent, pregunta) {
      //Logica per saber quin color s'ha de posar segons el percentatge
      //Agafem nomes el numero del percentatge sense el char %
      if (percent !== null && percent !== undefined) {
        if (percent.includes && percent.includes("%")) {
          percent = parseFloat(percent.replace("%", ""));
        } else {
          percent = parseFloat(percent);
        }
      }
      if (pregunta === 15 || pregunta === 16) {
        if (percent >= 8) {
          return "#00ab84";
        } else {
          return "#f4364c";
        }
      } else {
        if (percent >= 90) {
          return "#00ab84";
        } else if (percent < 90 && percent > 75) {
          return "#e1d906";
        } else if (percent === null || percent === "") {
          return "burlywood";
        } else {
          return "#f4364c";
        }
      }
    },
    actualitzarSectorSanitari(regio, sector) {
      if (
        regio !== null &&
        regio !== "" &&
        sector !== null &&
        sector.toString() !== ""
      ) {
        //Logica per poder veure seleccionat un sector
        // Elimina la clase 'selected' de qualsevol altre element de path seleccionat anteriorment
        const selectedPath = document.querySelector(".selected-sector");
        if (selectedPath) {
          selectedPath.classList.remove("selected-sector");
        }
        if (regio === "barcelona-ciutat") {
          const selectedPathBarcelona = document.querySelector(
            ".selected-sector-barcelona"
          );
          if (selectedPathBarcelona) {
            selectedPathBarcelona.classList.remove("selected-sector-barcelona");
          }
        }
        // Agrega la clase 'selected' al path actual seleccionat
        const currentPath = document.getElementById(sector);
        if (currentPath) {
          if (regio === "barcelona-ciutat") {
            currentPath.classList.add("selected-sector-barcelona");
          } else {
            currentPath.classList.add("selected-sector");
          }
        }

        // Agrega la clase 'non-selected' a tots els paths no seleccionats
        const allPaths = document.querySelectorAll(".land-sector");
        allPaths.forEach((path) => {
          if (path.id !== sector.toString()) {
            path.classList.add("non-selected-sector");
          } else {
            path.classList.remove("non-selected-sector");
          }
        });
        this.sectorSeleccionat = sector;
        this.$emit("sector-sanitari", this.sectorSeleccionat);
      }
    },

    seleccionarTotsElsSectors(event) {
      // Logica per a que quan es fa clic fora dels paths es "seleccionin" tots
      if (!event.target.closest("path")) {
        // Reinicia la regio seleccionada i aplica els estils corresponents
        this.sectorSeleccionat = null;
        this.$emit("sector-sanitari", this.sectorSeleccionat);
        const selectedPath = document.querySelector(".selected-sector");
        if (selectedPath) {
          selectedPath.classList.remove("selected-sector");
        }
        const selectedPathBarcelona = document.querySelector(
          ".selected-sector-barcelona"
        );
        if (selectedPathBarcelona) {
          selectedPathBarcelona.classList.remove("selected-sector-barcelona");
        }
        const allPaths = document.querySelectorAll(".land-sector");
        allPaths.forEach((path) => {
          path.classList.remove("non-selected-sector");
        });
      }
    },
  },
  mounted() {
    this.actualitzarSectorSanitari(
      this.regioSanitariaSeleccionada,
      this.sectorSanitariSeleccionat
    );
  },
};
</script>
<style scoped>

path {
  cursor: pointer;
  -webkit-transition: all 150ms;
  -moz-transition: all 150ms;
  -o-transition: all 150ms;
  transition: all 150ms;
}

path:hover {
  opacity: 0.85;
}

.land-sector {
  fill-opacity: 1;
  stroke: white;
  stroke-opacity: 1;
  stroke-width: 0.5;
}

.selected-sector {
  stroke: #000;
  stroke-width: 2;
}

.selected-sector-barcelona {
  stroke: #000;
  stroke-width: 0.5;
}

.non-selected-sector {
  opacity: 0.5;
}
</style>
